import {
    createElement, modal, loadingGif, validateField, clearMessage,
    toggleFieldError
} from 'commonAssets/js/helpers';
import { i18n, loading, outputDiv } from 'commonAssets/js/constants';
import { ErrorHandler } from 'commonAssets/utils/ErrorHandler';
import { SubmitClaim } from 'commonAssets/components/Forms/SubmitClaim';

import formDefault from '../docs/formDefault.json';

class CustomSubmitClaim extends SubmitClaim {

    async form() {
        try {
            const form = formDefault.claim_form[this.lang];
            this.init_claim(form);
        }
        catch (error) {
            this.errorHandler.log_exception(new Error('Error fetching claim form', { cause: error }));
            this.errorHandler.display(error);
        }
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                if (form.form_options.notice_confirmation.display === true) {
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const claimFormAlert =
                        document.getElementById("claim_form_alert");
                    if (claimFormAlert) {
                        claimFormAlert.remove();
                    }

                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            document.getElementById("guard").remove();
                            container.appendChild(
                                this.claim_form(form, datetime)
                            );
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });
                    }

                    document
                        .getElementById("submit-guard")
                        .addEventListener("click", () => {
                            document
                                .getElementById("guard")
                                .classList.add("was-validated");
                        });

                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        this.errorHandler.log_exception(
                                            new Error(
                                                "Error loading class member",
                                                { cause: result }
                                            )
                                        );
                                        this.errorHandler.display_modal(result);
                                        loadingGif(loading, "hide", 250);
                                        return;
                                    }

                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    const environment =
                                        this.claim.data.domain.split(".")[0];

                                    let cmLabel = false;
                                    let cmActive = false;
                                    let cmCanEdit = false;

                                    const ClassMemberStatus = Boolean(
                                        result.data.claim_id
                                    )
                                        ? result.data.class_member?.cm_data
                                            ?.ClassMemberStatus
                                        : result.data.cm_data
                                            ?.ClassMemberStatus;

                                    if (!Array.isArray(ClassMemberStatus)) {
                                        modal(
                                            "Error",
                                            "This portal is not available for new claims."
                                        );
                                        loadingGif(loading, "hide", 250);
                                        return;
                                    }

                                    for (const status of ClassMemberStatus) {
                                        if (status.Label !== "Deficient") {
                                            continue;
                                        }

                                        if (status.Deadline) {
                                            const deadlineDate = new Date(
                                                status.Deadline
                                            );
                                            if (new Date() > deadlineDate) {
                                                modal(
                                                    "Error",
                                                    "The deadline to Fix Claim has passed."
                                                );
                                                loadingGif(
                                                    loading,
                                                    "hide",
                                                    250
                                                );
                                                return;
                                            }
                                        }

                                        cmLabel = true;
                                        cmActive = Boolean(status.Active);
                                        cmCanEdit = Boolean(status.CanEdit);
                                        break;
                                    }

                                    if (!cmLabel || !cmActive || !cmCanEdit) {
                                        modal(
                                            i18n.getTranslation("error"),
                                            "This portal is not available for claim edits."
                                        );
                                        loadingGif(loading, "hide", 250);
                                        return;
                                    }

                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        this.claim.class_member = result.data;
                                        if (environment !== "local") {
                                            this.send_otp(
                                                form,
                                                container,
                                                result.data,
                                                claim_deadline
                                            );
                                            return;
                                        }
                                    }

                                    this.populate_claim_form(
                                        form,
                                        container,
                                        result.data,
                                        claim_deadline
                                    );
                                })
                                .catch((error) => {
                                    this.errorHandler.log_exception(
                                        new Error(
                                            "Error loading class member",
                                            { cause: error }
                                        )
                                    );
                                    this.errorHandler.display_modal(error);
                                    loadingGif(loading, "hide", 250);
                                });
                        });
                } else {
                    this.edit_claim(form);

                    container.appendChild(this.claim_form(form, datetime));
                    outputDiv.appendChild(container);

                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    init_claim_inputs() {
        const claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input, #claim-fields textarea, #claim-fields select';
        claimInputsFields += ', #attestations_div input, #attestations_div textarea, #attestations_div select';
        const claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        const claimInputsTransactions = '#transactions input, #transactions textarea, #transactions select';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    claim_documentation(params) {
        if (Boolean(params.claim_upload.documentation.required)) {

            const documentation = params.claim_upload.documentation;
            const fieldset = createElement("div", {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "documentation"
            }, [], "<div class=\"h3 mb-3 formTitle\">" + documentation.title + "</div>");

            const fieldsetLead = createElement("p", { class: "mb-3" }, [], documentation.body);
            fieldset.appendChild(fieldsetLead);

            const notice = createElement("p", { class: "mb-3" }, [], documentation.file_types_notice); fieldset.appendChild(notice);

            // Documentation Inputs
            const labelFileUpload = createElement("label", {
                for: "file-upload"
            }, [], `${documentation.label_file_upload}: <span class=\"error\"></span><span class=\"warning\"></span>`);
            const inputFileUpload = createElement("input", {
                type: "file",
                id: "file-upload",
                class: "form-control mb-3",
                name: "file-upload",
                "data-input": documentation.data_input,
                "data-validate": documentation.data_validate,
                "data-file-size": documentation.data_file_size,
                "data-file-type": documentation.data_file_type,
                "accept": documentation.accept,
            });
            const inputFileHash = createElement("input", {
                type: "hidden",
                id: "file-hash"
            });
            const groupFileUpload = createElement("div", {
                class: "mb-3"
            }, [labelFileUpload, inputFileUpload, inputFileHash]);
            fieldset.appendChild(groupFileUpload);

            const labelFileDesc = createElement("label", {
                for: "file-description"
            }, [], `${documentation.label_file_desc}: <span class="error"></span>`);
            const inputFileDescText = createElement("input", {
                type: "text",
                class: "form-control",
                id: "file-description",
                name: "file-description",
            });
            const inputFileDescBtn = createElement("input", {
                type: "button",
                class: "btn btn-primary",
                id: "file-add",
                value: "Upload File"
            });
            const inputGroup = createElement("div", {
                class: "input-group input-group-lg mb-3"
            }, [inputFileDescText, inputFileDescBtn]);
            const groupFileDesc = createElement("div", {
                id: "groupFileDesc"
            }, [labelFileDesc, inputGroup]);
            fieldset.appendChild(groupFileDesc);

            const parInstructions = createElement("p", { class: "text-center fw-bold mb-3" }, [], documentation.instructions); fieldset.appendChild(parInstructions);

            const fileListPar = createElement("p", {
                id: "fileList"
            }, [], `<strong>Uploaded Files:</strong> <span id="no-files">None</span>`);

            const fileOrderedList = createElement("ol", {
                class: "d-none",
                id: "file-list"
            });
            const fileListElem = createElement("div", {
                id: "fileListElem"
            }, [fileListPar, fileOrderedList]);
            fieldset.appendChild(fileListElem);

            return fieldset;
        }
    }

    static createInstance({ appClaimForm, userLanguage, customInitClaim = null, customProcessClaim = null, customLoadMember = null, customDstProcess = null, errorHandler = new ErrorHandler() }) {
        return new CustomSubmitClaim(appClaimForm, userLanguage, customInitClaim, customProcessClaim, customLoadMember, customDstProcess, errorHandler);
    }
}

export { CustomSubmitClaim as customSubmitClaim }
